import axios from 'axios';
import { Model } from '../types';

export async function getHistoricalModels(): Promise<Model[]> {
  const response = await axios.get(`/api/historical/models`);
  return response.data.data;
}
